module.exports = __webpack_public_path__ + "static/media/pdfDark.bf5be010.svg";